import React    from 'react';
import List  from '@material-ui/core/List';

export default function Divider(props) {
    return (
        <List  dense={true}>
            {props.children}
        </List>
    )
}